import { render, staticRenderFns } from "./RoundtableEdit.vue?vue&type=template&id=280a9950&"
import script from "./RoundtableEdit.vue?vue&type=script&lang=js&"
export * from "./RoundtableEdit.vue?vue&type=script&lang=js&"
import style0 from "./RoundtableEdit.vue?vue&type=style&index=0&id=280a9950&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports